import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ReactTooltipStyled } from '../../styled/typography/typographyExtentions'
import colors from '../../../configuration/colors'
import IconQuestion from '../../../static/images/Skills/icon_question.svg'
import { LexiconContext } from '../../../contexts/Lexicon'

const MasteryLegendContainer = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  padding: 0;
  margin: 0 0 35px;
`

const MasteryLegendItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${colors.black};
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
`

const MasteryLegendIcon = styled.div`
  height: 14px;
  width: 14px;
  background: no-repeat url(${IconQuestion});
  background-size: contain;
  margin-left: 6px;
`

export default class MasteryLegend extends Component {
  static contextType = LexiconContext

  render () {
    const { lexicon } = this.context

    return (
      <MasteryLegendContainer>
        <MasteryLegendItem
          data-tip={`Has not demonstrated evidence of this ${lexicon.skill.toLowerCase()}.`}
          data-for='not-familiar'
          data-multiline
        >
          Not Familiar<MasteryLegendIcon />

          <ReactTooltipStyled
            id='not-familiar'
            effect='solid' />
        </MasteryLegendItem>

        <MasteryLegendItem
          data-tip={`Expresses familiarity with the ${lexicon.skill.toLowerCase()}, shows awareness of the ${lexicon.skill.toLowerCase()} and attempts to demonstrate it.`}
          data-for='familiar'
          data-multiline
        >
          Familiar<MasteryLegendIcon />

          <ReactTooltipStyled
            id='familiar'
            effect='solid' />
        </MasteryLegendItem>

        <MasteryLegendItem
          data-tip={`Demonstrates evidence of the ${lexicon.skill.toLowerCase()}, but there is clear room for improvement.`}
          data-for='developing'
          data-multiline
        >
          Developing<MasteryLegendIcon />

          <ReactTooltipStyled
            id='developing'
            effect='solid' />
        </MasteryLegendItem>

        <MasteryLegendItem
          data-tip={`Demonstrates the ${lexicon.skill.toLowerCase()} in the intended manner, with evidence that the ${lexicon.skill.toLowerCase()} has been acquired.`}
          data-for='proficient'
        >
          Proficient<MasteryLegendIcon />

          <ReactTooltipStyled
            id='proficient'
            effect='solid' />
        </MasteryLegendItem>

        <MasteryLegendItem
          data-tip={`Demonstrates the ${lexicon.skill.toLowerCase()} in multiple contexts, applies the ${lexicon.skill.toLowerCase()} to new uses.`}
          data-for='mastering'
        >
          Mastering<MasteryLegendIcon />

          <ReactTooltipStyled
            id='mastering'
            effect='solid' />
        </MasteryLegendItem>

      </MasteryLegendContainer>
    )
  }
}

MasteryLegend.propTypes = {
  dispatch: PropTypes.func
}
